const { isExternalDeepLinkFromBackUrl } = require('./deeplinks');
/**
 * Method that insert a new param or update an existing one in the param url
 * @param {String} key
 * @param {String} value
 * @param {String} url
 */
const insertParam = (key, value, url) => {
  const params = url.substr(1).split('&');

  let i = params.length - 1;
  let keyAndValue;

  while (i) {
    keyAndValue = params[i].split('=');

    if (keyAndValue[0] === key) {
      keyAndValue[1] = value;
      params[i] = keyAndValue.join('=');

      break;
    }

    i -= 1;
  }

  if (i === 0) {
    params[params.length] = [key, value].join('=');
  }

  return `?${params.join('&')}`;
};

const containsHtmlEntities = (query) => {
  const htmlEntitiesRegex = /&(#[0-9]+|[a-z]+);/;

  return !!htmlEntitiesRegex.test(query);
};

const buildCheckoutURL = (req, replaceString, replacement) => {
    const { originalUrl } = req;
    const host = req.get('Host');
    if (replaceString?.length > 0 && replacement?.length > 0) {
      return `https://${host}${originalUrl.replace(replaceString, replacement)}`;
    }
    return `https://${host}${originalUrl}`;
}

const sanitizeUrl = (url) => {
  if (isExternalDeepLinkFromBackUrl(url)) {
    return url.replace(/^https?:\/\//, '')
  }
  return url;
}

const hasDangerousExtension = (url) => {
  if(!url) {
    return false;
  }
  const dangerousExtensionsPattern = /\.(exe|bat|cmd|msi|deb|js|vbs|ps1|sh|zip|rar|tar|gz|ini|xml|dll|dmg|apk)$/i;
  const resourcePath = url.split('?')[0];

  return dangerousExtensionsPattern.test(resourcePath);
};

// deep‐equals for two JS values (objects, arrays, primitives)
function deepEqual(a, b) {
  if (a === b) return true;
  if (typeof a !== typeof b) return false;
  if (a == null || b == null) return false;
  if (Array.isArray(a)) {
    if (!Array.isArray(b) || a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) {
      if (!deepEqual(a[i], b[i])) return false;
    }
    return true;
  }
  if (typeof a === "object") {
    const ka = Object.keys(a).sort();
    const kb = Object.keys(b).sort();
    if (ka.length !== kb.length) return false;
    for (let i = 0; i < ka.length; i++) {
      if (ka[i] !== kb[i]) return false;
      if (!deepEqual(a[ka[i]], b[kb[i]])) return false;
    }
    return true;
  }
  return false;
}

// normalize a URL (possibly custom‐scheme) into a canonical JS object
function normalizeUrl(input) {
  const url = new URL(input);
  // build a map: param name → array of values
  const rawParams = {};
  for (const [k, v] of url.searchParams) {
    if (!rawParams[k]) rawParams[k] = [];
    rawParams[k].push(v);
  }

  const params = {};
  for (const key of Object.keys(rawParams)) {
    // sort the raw values so order doesn't matter
    const values = rawParams[key].slice().sort();
    const normalizedValues = values.map(val => {
      // try to decode and see if it's a URL
      let decoded;
      try { decoded = decodeURIComponent(val); }
      catch (_) { decoded = null; }
      if (decoded && /^[a-z]+:\/\//i.test(decoded)) {
        // it's a nested URL → recurse
        return normalizeUrl(decoded);
      }
      // otherwise leave as a string
      return val;
    });
    params[key] = normalizedValues;
  }

  return {
    protocol: url.protocol,
    host:     url.host,
    pathname: url.pathname,
    params
  };
}

function areUrlsEquivalent(a, b) {
  const na = normalizeUrl(a);
  const nb = normalizeUrl(b);
  return deepEqual(na, nb);
}

module.exports = {
  insertParam,
  containsHtmlEntities,
  buildCheckoutURL,
  sanitizeUrl,
  hasDangerousExtension,
  areUrlsEquivalent,
  deepEqual,
  normalizeUrl,
};
